import * as React from 'react';

export type TextInputRowProps = {
    label: string;
    value: string;
    onChange: (newValue: string) => void;
    labelClassName?: string;
    inputClassName?: string;
    name?: string;
    disabled?: boolean;
    required?: boolean;
    inputColumnWidth?: number;
    labelColumnWidth?: number;
    inputRef?: React.Ref<HTMLInputElement>;
};

const TextInputRow: React.ForwardRefRenderFunction<HTMLInputElement, TextInputRowProps> = (
    {
        disabled = false,
        inputClassName = '',
        inputColumnWidth = 10,
        label,
        labelClassName = '',
        labelColumnWidth = 2,
        name = '',
        onChange,
        required = false,
        value = '',
    },
    inputRef,
) => {
    const [currentValue, setCurrentValue] = React.useState(value);
    const handleChange = (newValue: string) => {
        setCurrentValue(newValue);
        onChange(newValue);
    };
    return (
        <div className="form-group control-label">
            <label className={`col-sm-${labelColumnWidth} ${labelClassName}`}>{label}</label>
            <div className={`col-sm-${inputColumnWidth}`}>
                <input
                    className={`form-control ${inputClassName}`}
                    disabled={disabled}
                    name={name}
                    ref={inputRef}
                    required={required}
                    type="text"
                    value={currentValue}
                    onChange={event => handleChange(event.target.value)}
                />
            </div>
        </div>
    );
};

TextInputRow.displayName = 'TextInputRow';

export default React.forwardRef(TextInputRow);
